export const getEnv = () => import.meta.env.MODE

export const isLocal = import.meta.env.DEV
export const googleSiteKey = '6Lfk0XQqAAAAAEM7muRvF5l91uySBhpddqu9iTbB'
